import React from "react";
import { useLanguage } from "../context/LanguageContext";

const TEXTURE =
  "https://static.prod-images.emergentagent.com/jobs/a9198dff-57f1-4437-9e3e-dffc53d8f216/images/5924aeada4a0b5544dc72949de43ab83069f1ca55ba2ba932bfb5d656156e981.png";

export const About = () => {
  const { t } = useLanguage();

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 lg:py-36 bg-[#0A0A0A] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Left column: image */}
          <div className="lg:col-span-5">
            <div className="sticky top-32">
              <div className="relative aspect-[4/5] overflow-hidden border border-white/10">
                <img
                  src={TEXTURE}
                  alt="Strumenti del Proscenio Ensemble"
                  className="w-full h-full object-cover grayscale-[20%] hover:grayscale-0 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              </div>
              <div className="mt-6 grid grid-cols-3 gap-6">
                {t.about.stats.map((s, i) => (
                  <div key={i} data-testid={`about-stat-${i}`}>
                    <div className="font-serif-display text-3xl lg:text-4xl text-[#D4AF37]">
                      {s.value}
                    </div>
                    <div className="text-xs tracking-wider text-[#71717A] uppercase mt-1 leading-tight">
                      {s.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right column: text */}
          <div className="lg:col-span-7">
            <div className="overline" data-testid="about-overline">
              {t.about.overline}
            </div>
            <h2
              data-testid="about-title"
              className="font-serif-display font-light mt-5 text-4xl md:text-5xl lg:text-6xl text-[#FDFBF7] leading-[1.05] tracking-tight"
            >
              {t.about.title}
            </h2>

            <div className="mt-10 space-y-6 text-[#A1A1AA] text-base lg:text-[17px] leading-[1.85] font-light">
              {t.about.paragraphs.map((p, i) => (
                <p
                  key={i}
                  data-testid={`about-paragraph-${i}`}
                  className={i === 0 ? "first-letter:font-serif-bodoni first-letter:text-5xl first-letter:text-[#D4AF37] first-letter:float-left first-letter:mr-3 first-letter:leading-[0.9]" : ""}
                >
                  {p}
                </p>
              ))}
            </div>

            <div className="mt-12 divider-ornament" aria-hidden="true">
              <span className="font-serif-bodoni italic text-sm">
                Proscenio Ensemble
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
